<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headersByType"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.last_name="{ item }">
        <span class="mr-2">{{ item.last_name }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="{
            name: 'persons.show',
            params: { id: item.person_id }
          }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">mdi-eye-outline</v-icon>
            </template>
            <span v-if="item.last_name">{{ item.last_name }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.from="{ item }">
        {{ item.from | dateFormat }}
      </template>

      <template v-slot:item.to="{ item }">
        {{ item.to | dateFormat }}
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | dateFormat }}
      </template>

      <template v-slot:item.include_in_rent="{ item }">
        <v-checkbox v-model="item.include_in_rent" disabled dense />
      </template>

      <template v-slot:item.building_complex_name="{ item }">
        <span class="mr-2">{{ item.building_complex_name }}</span>
        <router-link
          v-if="item.building_complex_id"
          class="text-decoration-none"
          target="_blank"
          :to="{
            name: 'building_complexes.show',
            params: { id: item.building_complex_id }
          }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">
                mdi-eye-outline
              </v-icon>
            </template>
            <span v-if="item.building_complex_name">{{
              item.building_complex_name
            }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.status_id="{ item }">
        <div v-if="!isEmptyObject(item.status)">
          <v-chip
            v-if="item.status.color"
            :color="item.status.color"
            text-color="white"
            small
          >
            {{ item.status.name }}
          </v-chip>
          <div v-else>
            {{ item.status.name }}
          </div>
        </div>
        <div v-else>
          {{ item.status }}
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="$emit('show', item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isEmpty, isEqual } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';
import listItems from '@/modules/_global/mixins/list-items';

export const ALL = 'all';
export const PERSON = 'person';

export const types = Object.freeze({
  ALL,
  PERSON
});

export default {
  name: 'SubscriptionsList',

  filters: {
    dateFormat
  },

  mixins: [listItems],

  props: {
    type: {
      type: String,
      default: ALL,
      validator: prop => Object.values(types).includes(prop)
    }
  },

  data() {
    return {
      columnsByType: {
        [PERSON]: [6, 1, 4, 5, 8, 9, 10],
        [ALL]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      }
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ABO_SERVICES.ITEM'),
          value: 'service_name'
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          value: 'first_name'
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          value: 'last_name'
        },
        {
          text: this.$t('SUBSCRIPTIONS.DATE_FROM'),
          value: 'from'
        },
        {
          text: this.$t('SUBSCRIPTIONS.DATE_TO'),
          value: 'to'
        },
        {
          text: this.$t('ITEM.DATE_ENTERED'),
          value: 'created_at'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex_name'
        },
        {
          text: this.$t('SUBSCRIPTIONS.INCLUDE_IN_RENT'),
          value: 'include_in_rent'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'status_id'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: this.$can('sensitive-data') ? 'center' : ' d-none'
        }
      ];
    },

    columns() {
      return this.columnsByType[this.type];
    },

    headersByType() {
      return this.columns.map(i => this.headers[i]).filter(Boolean);
    }
  },

  methods: {
    isEmptyObject(v) {
      return isEmpty(v);
    }
  }
};
</script>
